export default __webpack_public_path__ + "static/media/temp-mail.cc465868.png";